import React from 'react';
import Icon from '../icon/Icon';
import classNames from 'classnames';
import { Spinner } from '../loading/Spinner';
const Button = ({ children, type, color, size, style, onClick, className, disabled, isLoading, iconPath, iconSize, iconPosition, id, itemProp, itemScope, itemType, isActive, }) => {
    let classNameResult = classNames('ac-btn', color || 'primary', size || 'md', `icon-${iconPosition || 'left'}`, `style-${style || 'primary'}`, { active: isActive }, className || '');
    const renderIcon = () => {
        if (isLoading) {
            let loadingColor = 'white';
            switch (color) {
                case 'lime':
                case 'warning':
                case 'yellow100':
                case 'white':
                case 'gradient': {
                    loadingColor = 'auto';
                }
            }
            if (style === 'ghost' || style === 'outline') {
                loadingColor = 'auto';
            }
            return (React.createElement("div", { className: 'spinner-wrapper' },
                React.createElement(Spinner, { size: 'xs', className: classNames('d-flex align-items-center justify-content-center', loadingColor) })));
        }
        else if (iconPath) {
            return React.createElement(Icon, { path: iconPath, size: iconSize, title: undefined });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    return (React.createElement("button", { itemProp: itemProp, itemScope: itemScope, itemType: itemType, id: id, type: type, onClick: onClick, onMouseDown: (e) => e.preventDefault(), className: classNameResult, disabled: disabled },
        React.createElement("div", { className: 'button-container' },
            renderIcon(),
            React.createElement("span", { className: 'button-content' }, children))));
};
export { Button };
//# sourceMappingURL=Button.js.map